<template>
    <main role="main" class="container">
        <div class="row justify-content-center ">
            <div class="col col-10 text-center">
                <h1>{{ name }}</h1>
            </div>
        </div>
        <router-view />
    </main>
</template>

<style lang="scss">
@import 'src/scss/main'
</style>

<script>
    export default {
        data() {
            return {
                name: "U Hrocha"
            }
        },
        name: 'app',
    }
</script>